module.exports = {"abalone":4,"abare":3,"abed":2,"abruzzese":4,"abbruzzese":4,"aborigine":5,"acreage":3,"adame":3,"adieu":2,"adobe":3,"anemone":4,"apache":3,"aphrodite":4,"apostrophe":4,"ariadne":4,"cafe":2,"calliope":4,"catastrophe":4,"chile":2,"chloe":2,"circe":2,"coyote":3,"epitome":4,"forever":3,"gethsemane":4,"guacamole":4,"hyperbole":4,"jesse":2,"jukebox":2,"karate":3,"machete":3,"maybe":2,"people":2,"recipe":3,"sesame":3,"shoreline":2,"simile":3,"syncope":3,"tamale":3,"yosemite":4,"daphne":2,"eurydice":4,"euterpe":3,"hermione":4,"penelope":4,"persephone":4,"phoebe":2,"zoe":2}


//////////////////
// WEBPACK FOOTER
// ./node_modules/syllable/problematic.json
// module id = 251
// module chunks = 0